<div class="redirect-to-external-link-modal">
  <h4>You are being redirected to an external site.<br/>By closing the new tab you will return to this page.</h4>
</div>
